import React from "react";
import { useSearchParams } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useBookingFlow } from "../hooks/useBookingFlow";
import { BookingStepper } from "../components/booking/BookingStepper";
import { ServiceStep } from "../components/booking/ServiceStep";
import { SlotStep } from "../components/booking/SlotStep";
import { DetailsStep } from "../components/booking/DetailsStep";
import { BookingSummary } from "../components/booking/BookingSummary";
import { BookingConfirmation } from "../components/booking/BookingConfirmation";
export function Booking() {
  const [params] = useSearchParams();
  const flow = useBookingFlow(params.get("service"));
  return <div className="min-h-full bg-surface" data-id="element-380" data-mp="gbt0sfi9xw74">
      <div className="mx-auto max-w-6xl px-5 py-10 md:px-8 md:py-14" data-id="element-381" data-mp="geyuk81ulm96">
        {flow.step === "done" && flow.confirmed && flow.service ? <BookingConfirmation appointment={flow.confirmed} service={flow.service} data-id="element-382" data-mp="qa8umq8orjkb" /> : <>
            <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-383" data-mp="1rh6e8pdugipv">
              <h1 className="text-3xl font-semibold tracking-tight text-ink md:text-4xl" data-id="element-384" data-mp="1mfz7mtnftpks">Prendre rendez-vous</h1>
              <BookingStepper current={flow.step} canGoTo={flow.canGoTo} onStepClick={flow.goToStep} data-id="element-385" data-mp="1ig8b09b8cf8c" />
            </div>

            <div className="mt-8 grid items-start gap-6 lg:grid-cols-[1fr_340px] lg:gap-8" data-id="element-386" data-mp="1di6v1x93ow13">
              <section className="overflow-hidden rounded-3xl border border-line bg-white p-6 md:p-8" data-id="element-387" data-mp="2a5tjb7w0t83g">
                <AnimatePresence mode="wait" initial={false} data-id="element-388" data-mp="265t43l13ksvc">
                  <motion.div key={flow.step} initial={{
                opacity: 0,
                x: 8
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: -8
              }} transition={{
                duration: 0.18,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-389" data-mp="21d9grwclyjdc">
                    {flow.step === "service" && <ServiceStep selectedId={flow.service?.id ?? null} onSelect={flow.selectService} data-id="element-390" data-mp="380e206ev6kx7" />}
                    {flow.step === "slot" && flow.service && <SlotStep service={flow.service} dateKey={flow.dateKey} time={flow.time} onSelectDate={flow.selectDate} onSelectTime={flow.setTime} onContinue={() => flow.goToStep("details")} data-id="element-391" data-mp="2z7slyy2masc2" />}
                    {flow.step === "details" && flow.service && <DetailsStep service={flow.service} hasPrescription={flow.hasPrescription} onPrescriptionChange={flow.setHasPrescription} note={flow.note} onNoteChange={flow.setNote} canConfirm={flow.canConfirm} submitting={flow.submitting} error={flow.error} onConfirm={flow.confirm} onChangeSlot={() => flow.goToStep("slot")} data-id="element-392" data-mp="2ga9ie9yxi1x1" />}
                  </motion.div>
                </AnimatePresence>
              </section>

              <BookingSummary service={flow.service} dateKey={flow.dateKey} time={flow.time} onEdit={flow.goToStep} data-id="element-393" data-mp="27yr5b7ineinb" />
            </div>
          </>}
      </div>
    </div>;
}